import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { isBrowser } from 'react-device-detect';
import Logo from '../../UI/Logo';
import UIButton from '../../UI/UIButton';
import { MediumTitle, wh, fadeInAnimation, screenPadding } from '../../mixins';
import BackButton from '../../UI/BackButton';
import { sendAnalyticsEvents } from '../../analytics/common';
import { EVENTS } from '../../analytics/events';
import { selectToken } from '../signup/signupSlice';
import { selectLandingType } from '../plans/plansSlice';
import { selectEventsData, selectAnalyticsData } from '../events/eventsSlice';

const APP_LINK = process.env.REACT_APP_WEB_APP_URL;

const StyledContainer = styled.div`
  ${wh('100%')};
  ${isBrowser && fadeInAnimation};
  ${screenPadding};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  @media screen and (min-width: 768px) {
    padding: 24px 6px 32px;
    height: calc(100vh - 116px);
    min-height: unset;
  }
`;

const Title = styled.h1`
  ${MediumTitle};
  margin-top: 32px;
  margin-bottom: auto;
`;

const DownloadScreen = ({ history }) => {
  const { t } = useTranslation();
  const token = useSelector(selectToken);
  const landingType = useSelector(selectLandingType);
  const amplitudeEventsData = useSelector(selectEventsData);
  const facebookPurchaseParams = useSelector(selectAnalyticsData);

  const eventsDataEncoded = btoa(
    unescape(
      encodeURIComponent(
        JSON.stringify({ ...amplitudeEventsData, ...facebookPurchaseParams })
      )
    )
  );

  useEffect(
    () => sendAnalyticsEvents(EVENTS.downloadScreenShown, amplitudeEventsData),
    [amplitudeEventsData]
  );

  const onStartClick = () => {
    const url = `${APP_LINK}onboarding-login?token=${token}&data=${eventsDataEncoded}&offerType=${landingType}`;
    window.location.assign(url);
  };

  const onBackClick = () => {
    history.push('/checkout');
  };

  return (
    <StyledContainer>
      <BackButton analyticsEvent={onBackClick} />
      <Logo />
      <Title>{t('download_gz')}</Title>
      <UIButton onClick={onStartClick}>{t('start_tracking')}</UIButton>
    </StyledContainer>
  );
};

export default DownloadScreen;
